import { Outlet } from "react-router-dom";

export default function StudentWrapper(props) {
  return <Outlet />;
}
